/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CarrierInvoiceState {
  Voided = "voided",
  InAudit = "in_audit",
  Approved = "approved",
  FundsSent = "funds_sent",
  Reconciled = "reconciled",
}

export function instanceOfCarrierInvoiceState(value: any): boolean {
  for (const key in CarrierInvoiceState) {
    if (Object.prototype.hasOwnProperty.call(CarrierInvoiceState, key)) {
      if (
        CarrierInvoiceState[key as keyof typeof CarrierInvoiceState] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierInvoiceStateFromJSON(json: any): CarrierInvoiceState {
  return CarrierInvoiceStateFromJSONTyped(json, false);
}

export function CarrierInvoiceStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierInvoiceState {
  return json as CarrierInvoiceState;
}

export function CarrierInvoiceStateToJSON(
  value?: CarrierInvoiceState | null,
): any {
  return value as any;
}

export function CarrierInvoiceStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierInvoiceState {
  return value as CarrierInvoiceState;
}
